import React from "react";
import { IconButton } from "components";
import { useStyles } from "./styles";
import {
  useIsDisabledFilterButton,
  useMyFleetOperations,
} from "../SearchCarMyFleet";
import { Badge } from "e100-react-components";
import { useIsEmptyFilter } from "features/myFleet";

export const FilterCarMyFleetButton = () => {
  const classes = useStyles();
  const isDisabledFilterButton = useIsDisabledFilterButton();
  const { setActiveDisplay } = useMyFleetOperations();
  const isEmptyFilter = useIsEmptyFilter();

  const onClick = () => {
    setActiveDisplay("filterForm");
  };

  return (
    <Badge
      color="primary"
      variant="dot"
      invisible={isEmptyFilter}
      classes={{
        anchorOriginTopRightRectangle: classes.badgeTopRightRectangle,
      }}
    >
      <IconButton
        kind="setting"
        classes={{ root: classes.iconButton }}
        onClick={onClick}
        disabled={isDisabledFilterButton}
      ></IconButton>
    </Badge>
  );
};
